export enum TopchansTypeText {
	ordinary = 'Обычный',
	vip = 'VIP'
}
